<template>
  <div v-if="docs?.length" class="doc-com">
    <van-list class="" @load="onLoad" finished-text="没有更多了" :finished="finished" v-model="loadings">
      <div v-for="(item, index) in docs" :key="index">
        <div class="doc" @click="toDocDetail(item.docType, item.uuid, item.linkUrl)">
          <div class="doc-left">
            <img :src="item.picUrl" alt="">
          </div>
          <div class="doc-right">
            <div class="doc-title">{{ item.title }}</div>
            <div class="doc-bottom">
              <div>{{ item.releaseTime }}</div>
              <div>{{ item.readAmount + '人已看' }}</div>
            </div>
          </div>
        </div>
        <van-divider />
      </div>
    </van-list>
  </div>
</template>
<script>
import { useValidateUrl } from '@/assets/js/utils'
export default {
  name: 'ColumnDocs',
  data() {
    return {
      loading: this.loading
    }
  },
  props: {
    docs: Array,
    loadings: Boolean,
    finished: Boolean
  },
  methods: {
    onLoad() {
      this.$emit('onLoad')
    },
    async toDocDetail(type, id, url) {
      if (type == 1) {
        this.$router.push('/DocumentDetail?id=' + id + '&sou=' + this.$route.query.sou)
      } else if (type == 24) {
        this.$router.push('/Live?id=' + id + '&sou=' + this.$route.query.sou)
      } else if (type == 19) {
        if (!useValidateUrl(url)) return
        await this.$https.addReadNum({
          uuid: id
        })
        window.location.href = url
      }
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (min-width: 1000px) {
  .doc-com {
    width: 652px !important;
    .doc {
      .doc-right {
        .doc-title {
          width: 554px !important;
        }
      }
    }
  }
}
.doc-com {
  margin: 24px 16px 0;
  width: calc(100vw - 32px);
  .doc {
    margin: 12px 0;
    display: flex;
    .doc-left {
      // position: relative;
      width: 80px !important;
      height: 60px !important;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .doc-right {
      margin-left: 12px;
      .doc-title {
        width: calc(100vw - 136px);
        height: 40px;
        font-size: 16px;
        color: #000;
        line-height: 20px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .doc-bottom {
      margin-top: 4px;
      font-size: 12px;
      color: #9898A2;
      line-height: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
/deep/.van-divider {
  margin: 12px 0;
  color: #E9EEED;
}
</style>